// constants/colors.js
export const COLORS = {
    BACKGROUND_WHITE: "#ffffff",
    TEXT_BLACK: "#333333",
    TEXT_GRAY: "#555555",
    TEXT_WHITE: "#fdfdfd",
    TEXT_RED: "#ad3d48",
    LIGHT_GRAY: "#f0f0f0",
    DARK_GRAY: "#666666",
    GRAY: "#e0e0e0",
    FOOTER: "#594F4F",
    RIBBON: "#EC3B5B",
    BUTTON_GRADIENT: "linear-gradient(45deg, #EE5B7B 30%, #FF8E53 90%)",
    CLEAR_GREEN: "#3CB350",
    LIGHT_BLUE: "#69BFEA",
    SKY_BLUE: "#3887fd",
    CLEAR_ORANGE: "#FFD8B0",
};